
class TextEtapes {
  constructor() {
    this._init();
  }

  _init() {
  }
}

export const textEtapes = new TextEtapes();
